import type { BeforeErrorHook } from "ky";
import { isHTTPError } from "ky";

import { hideLoader } from "@/redux/actions/loader";
import store from "@/redux/store";

const dispatch = store.dispatch;

// Only fires for network errors and timeouts — HTTPErrors already went through loaderEndHook
export const loaderErrorHook: BeforeErrorHook = ({ error }) => {
  if (!isHTTPError(error)) {
    dispatch(hideLoader());
  }

  return error;
};
